import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'

class AttachmentsTr extends React.Component {
  state = {
    attachments: this.props.fieldValue
  }

  downloadAttachment = (attachment) => {
    axios.get('/download_attachment/' + attachment.id)
    .then(function (response) {
      toastr.info('Attachment downloading')
    })
    .catch(function (error) {
      toastr.error('An error occured, please try again.')
      console.log(error)
    })
  }

  deleteAttachment = (attachment) => {
    if (confirm('Are you sure you want to delete this attachment?') == true) {
      var that = this
      var attachments = _.reject(this.state.attachments, {id: attachment.id})

      axios.delete('/attachments/' + attachment.id)
      .then(function (response) {
        that.setState({
          attachments: attachments
        })

        toastr.error('Attachment deleted')
      })
      .catch(function (error) {
        toastr.error('An error occured, please try again.')
        console.log(error)
      })
    }
  }

  render() {
    var that = this

    var attachments = this.state.attachments.map((attachment, index) => {
      return(
        <div className='col-xs-12 col-md-6'
             key={index}>
          <a href={attachment.original}
             className='styled-link pointer-hand'
             target='_blank'>

             {attachment.variable ? (
               <img width='200'
                    title={attachment.original}
                    alt='Attachment'
                    src={attachment.thumbnail} />
              ) : (
                <div className='grey-card'>
                  {attachment.filename}
                </div>
              )}
          </a>
          <br />
          <a className='pointer-hand'
             href={attachment.original}
             target='_blank'>
            <i className='material-icons pink-text indigo500 icon-in-row'>
              open_in_new
            </i>
          </a>
          <a className='pointer-hand'
             href={attachment.download_url}>
            <i className='material-icons pink-text indigo500 icon-in-row'>
              cloud_download
            </i>
          </a>
          <a className='pointer-hand'
             onClick={ ()=> that.deleteAttachment(attachment) }>
            <i className='material-icons pink-text indigo500 icon-in-row'>
              delete
            </i>
          </a>
        </div>
      )
    })

    return(
      <tr>
        <th>
          Attachments
        </th>
        <td>
          {attachments.length > 0 ? (
            <div className='row'>
              {attachments}
            </div>
          ) : (
            '-'
          )}
        </td>
      </tr>
    )
  }
}

AttachmentsTr.propTypes = {
  fieldName: PropTypes.string,
  fieldValue: PropTypes.array
}

export default AttachmentsTr
